"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionMoveToJobModal = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var autocomplete_menu_1 = require("../../components/autocomplete.menu/autocomplete.menu");
var input_1 = require("../../components/input/input");
var input_state_1 = require("../../components/input/input.state");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var store_1 = require("../../store");
var job_card_1 = require("../job.assign.modal/job.card");
var collection_move_modal_ctrl_1 = require("./collection.move.modal.ctrl");
var collection_move_modal_style_1 = require("./collection.move.modal.style");
(0, theme_1.addStyles)(collection_move_modal_style_1.Style);
var CollectionMoveToJobModal = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionMoveToJobModal, _super);
    function CollectionMoveToJobModal(ctx, collections) {
        var _this = _super.call(this, ctx) || this;
        _this.selectedJob = null;
        _this.ctrl = new collection_move_modal_ctrl_1.CollectionMoveModalCtrl(collections);
        _this.collections = collections;
        _this.jobInputState = new input_state_1.InputState('Job');
        _this.addState(_this.jobInputState);
        _this.autoMenu = new autocomplete_menu_1.AutoCompleteMenu({
            inputState: _this.jobInputState,
            options: function () { return _this.jobOptions; },
            optionView: function (option, nameParts) { return _this.viewJobCard(option, nameParts); },
            onselect: function (option) { return _this.selectJob(option); }
        });
        return _this;
    }
    Object.defineProperty(CollectionMoveToJobModal.prototype, "jobOptions", {
        get: function () {
            var rawJobs = store_1.AppStore.Tag.all;
            var jobs = rawJobs
                .filter(function (job) { return Boolean(store_1.AppStore.TagSummary.get(job.objectId)); })
                .map(function (tagObject) { return ({ id: tagObject.objectId, value: tagObject.name }); });
            return jobs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionMoveToJobModal.prototype, "nodes", {
        get: function () {
            return (0, mithril_1.m)('div', { className: collection_move_modal_style_1.CSS.container }, [
                (0, mithril_1.m)('div', { className: collection_move_modal_style_1.CSS.jobContent }, [
                    (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MOVE_CONFIRM, { count: this.ctrl.collections.length })),
                    this.jobSelector()
                ]),
                (0, mithril_1.m)('div', { className: collection_move_modal_style_1.CSS.menu }, this.autoMenu.view())
            ]);
        },
        enumerable: false,
        configurable: true
    });
    CollectionMoveToJobModal.prototype.viewJobCard = function (option, nameParts) {
        var _this = this;
        return { view: job_card_1.JobModalCard.viewCard({ tag: store_1.AppStore.Tag.get(option.id) }, nameParts), action: function () { return _this.selectJob(option); } };
    };
    CollectionMoveToJobModal.prototype.jobSelector = function () {
        var _this = this;
        if (!this.selectedJob) {
            return input_1.Input.view(this.jobInputState);
        }
        return job_card_1.JobModalCard.viewChip({ tag: store_1.AppStore.Tag.get(this.selectedJob), cancel: function () { return _this.selectJob(); } });
    };
    CollectionMoveToJobModal.prototype.validate = function () {
        if (!this.jobInputState._value && !this.selectedJob) {
            this.jobInputState.setError((0, i18n_1.Translate)(i18n_1.T.COLLECTION_MOVE_JOB_INPUT_ERROR));
        }
        else {
            this.jobInputState.setError('');
        }
    };
    CollectionMoveToJobModal.prototype.submit = function () {
        var tagName = this.selectedJob != null ? store_1.AppStore.Tag.get(this.selectedJob).name : this.jobInputState.value;
        return services_1.Services.Collection.move(this.collections, tagName);
    };
    CollectionMoveToJobModal.prototype.selectJob = function (option) {
        if (option != null) {
            this.selectedJob = option.id;
        }
        else {
            this.selectedJob = null;
            this.jobInputState.setValue('');
        }
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionMoveToJobModal.prototype, "selectedJob", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], CollectionMoveToJobModal.prototype, "jobOptions", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionMoveToJobModal.prototype, "selectJob", null);
    return CollectionMoveToJobModal;
}(modal_form_component_1.ModalFormComponent));
exports.CollectionMoveToJobModal = CollectionMoveToJobModal;
//# sourceMappingURL=collection.move.job.modal.js.map